import { useFlags } from "launchdarkly-react-client-sdk";
import { PropsWithChildren } from "react";

import { useIntercomLauncher } from "./launcher-visibility";

/**
 * Wrap this component around the routes of the app where we want an Intercom
 * launcher.
 * This reveals Intercom's own launcher in the bottom right corner for as long
 * as the subtree is mounted; elsewhere the messenger stays hidden until the
 * sidebar's "Chat with us" item opens it.
 */
export const IntercomLauncherWrapper = (props: PropsWithChildren) => {
  const { intercomChat } = useFlags();
  useIntercomLauncher(intercomChat === true);

  return <>{props.children}</>;
};
